import { FormControl as FC } from '@material-ui/core'
import styled from 'styled-components'

export const FormControl = styled(FC)`
  width: 100%;

  *:not(svg) {
    font-size: 14px;
  }

  div[class^='MuiInputBase-root'] {
    display: flex;
  }

  .MuiOutlinedInput-root {
    border-radius: 4px;
  }
`
